"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'step.form.title.edit': 'Editar Paso',
    'step.form.title.add': 'Agregar Paso',
    'step.form.back': 'Atrás',
    'step.form.title.label': 'Título',
    'step.form.title.placeholder': 'Título del paso',
    'step.form.order.label': 'Orden',
    'step.form.order.placeholder': 'Orden del paso',
    'step.form.isShared.label': 'Paso Compartido',
    'step.form.profession.label': 'Profesión',
    'step.form.profession.placeholder': 'Seleccionar profesión',
    'step.form.description.label': 'Descripción',
    'step.form.description.placeholder': 'Descripción',
    'step.form.questions.title': 'Preguntas',
    'step.form.questions.add': 'Agregar Pregunta',
    'step.form.questions.remove': 'Eliminar',
    'step.form.questions.empty': 'Aún no se han agregado preguntas. Haga clic en "Agregar Pregunta" para empezar.',
    'step.form.questions.order': 'Pregunta',
    'step.form.submit.update': 'Actualizar Paso',
    'step.form.submit.create': 'Crear Paso',
};
